/**
 * Training Status API - polls GET /api/training/status/:id.
 *
 * The /status 200 body is the minimal top-level shape
 * { status, progress, current_step, completed_at } with NO `success` key, so it
 * must NOT go through httpClient (whose `!data.success` gate would discard it).
 * We raw-fetch and return the parsed body, consistent with the other pollers.
 */

import { API_CONFIG } from '@/features/training/config/constants';
import { getAuthToken } from '../../core/auth/supabase-auth';
import { TrainingStatusResponse } from '../types/apiTypes';
import { logError } from '../utils/errorHandler';

export const trainingStatusApi = {
  pollTrainingStatus: async (sessionId: string): Promise<TrainingStatusResponse> => {
    try {
      const token = await getAuthToken();
      const response = await fetch(
        `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.TRAINING_STATUS}/${sessionId}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token ?? ''}`,
            'Content-Type': 'application/json',
          },
        }
      );
      // Return the parsed top-level body regardless of `success` (a 200 here has none).
      return (await response.json()) as TrainingStatusResponse;
    } catch (error) {
      logError('trainingStatusApi.pollTrainingStatus', error);
      throw error;
    }
  },
};
